<style scoped>
  .donate-header {
    /* background: #eee; */
    /* padding: 10px; */
    display: flex;
    flex-direction: column;
  }

  .secured{
    margin-top: 5px;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .card-image{
    width: auto;
    margin-right: 5px;
    border: 1px solid #ddd;
    border-radius: 5px;
    height: 20px;
  }

  .card-image.selected {
    background: #533efe;
    border-radius: 5px;
    padding: 10px;
  }

  .donate-body{
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  .cards {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin-top: 0px;
  }

  /* .select-amount > .amounts{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
  } */

  /* .amounts > .amount{
    margin-top: 10px;
    margin-right: 5px;
    margin-left: 5px;
  } */

  .amount > button{
    min-width: 100px;
  }

  .card-info {
    padding: 10px;
  }

  .card-info > .name,
  .card-info > .city,
  .card-info > .contact {
    display: flex;
  }

  .success-container{
    text-align: center;
  }

  .success-container > .success{
    color: #33a959;
    font-size: 4em;
  }

  .card-security-info{
    display: flex;
  }

  .payment-amount{
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
  }

  .security-info{
    position: absolute;
    z-index: 99;
    right: 15px;
    margin-top: -56px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 5px;
    padding: 10px;
    line-height: 1.5;
    top: 291px;
    width: 298px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  }

  .info-image{
    display: flex;
  }

  .info-images > img {
    height: auto;
    width:120px;
  }

  .demo-spin-icon-load{
    font-size: 4em !important;
  }

  .ivu-spin-text > div{
    font-size: 1.2em;
  }

  .form{
    display: flex;
    width: 100%;
    white-space: nowrap;
  }

  .form > .underline{
    border-bottom: 1px solid #949494;
    width: -webkit-fill-available;
  }
</style>

<style>
  .donate-header > .ivu-steps.ivu-steps-small .ivu-steps-title {
    font-weight: 400 !important;
  }

  .donate-header > .ivu-steps .ivu-steps-title {
    /* display: block !important; */
  }

  .bottom-buttons {
    vertical-align: middle;
    display: table;
    width: 100%;
  }

  .bottom-buttons .inner{
    vertical-align: middle;
    display: table-cell;
  }
  .bottom-buttons > .ivu-btn-text:focus{
    box-shadow: none !important;
  }

  button.active{
    box-shadow:  unset !important;
    background: #EF5350 !important;
    border-color: #EF5350 !important;
  }

  .security > .ivu-input-wrapper.ivu-input-type > input.ivu-input{
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
  }

  .expiration > .ivu-input-wrapper.ivu-input-type > input.ivu-input{
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }

  .ivu-form-item {
    /* margin-bottom: 15px !important; */
  }

  .ivu-form-item-content{
    /* position: inherit; */
  }

  .card-security-info > .ivu-form-item{
    width: 100%;
  }

  .other-amount > .ivu-row > .ivu-col.ivu-col-span-16 > .ivu-input-wrapper.ivu-input-wrapper-large.ivu-input-type > .ivu-input:focus{
    border-color: #EF5350 !important;
    box-shadow:  unset !important;
  }

  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }


  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }

  .online-payment-component{
    position: relative;
    margin-bottom: 10px;
    height: 100%;
  }

  .security > .ivu-input-wrapper > .ivu-input-group-append > span > .ivu-poptip > .ivu-poptip-popper > .ivu-poptip-content > .ivu-poptip-arrow:after{
    border-top-color: #539ce8;
  }

  .security > .ivu-input-wrapper > .ivu-input-group-append > span > .ivu-poptip > .ivu-poptip-popper > .ivu-poptip-content > .ivu-poptip-inner{
    background-color: #539ce8;
  }
</style>

<template>
  <div class="online-payment-component">
    <div class="donate-header">
    </div>
    <div class="donate-body" style="height: 55vh;overflow: hidden auto;display: block;">
      <div class="step-1" v-if="current == -1" style="width:99%">
          <div class="initial-page">
            <h3 align="center" style="margin-bottom:20px">Type of donation:</h3>
            <div class="donate-body">
              <div class="action-buttons">
                <div class="online-donation" style="text-align: center;margin-bottom: 15px;">
                  <Button style="width:150px" type="primary" class="process-button"
                    :class="{ active: typeOfDonation === 1 }" v-on:click="typeOfDonation = 1; next()">Online Donation</Button>
                  <div v-if="false" class="cards" style="margin-top: 5px;">
                    <img alt=" " src="@/assets/visa.png" class="card-image">
                    <img alt=" " src="@/assets/master-card.png" class="card-image">
                    <img alt=" " src="@/assets/paypal.png" class="card-image">
                  </div>
                </div>
                <div class="direct-deposit">
                  <Button style="width:150px" type="primary" class="process-button" :class="{ active: typeOfDonation === 2 }"
                    v-on:click="typeOfDonation = 2; next()">Direct Deposit</Button>
                </div>
              </div><br/>

            </div><br/>
            <!-- <div style="text-align: center;">
              <Button type="primary" style="margin-top:15px; font-size: 20px" :disabled="typeOfDonation == 0" size="large" long @click="next">Next step</Button>
            </div> -->
          </div>
      </div>
      <div class="step-1" v-if="current == 0" style="width:99%">
        <div class="select-amount">
          <h3>Select amount:</h3>
          <div class="amounts">
            <Row :gutter="16">
              <div class="amount" v-for="(amount, indx) in amounts" :key="indx">
                <Col span="8">
                  <Button type="primary" :class="{ active: activeAmount === indx }" v-if="indx < 6"
                    v-on:click="activeAmount = indx; next()" style="width: 100%;margin-top: 10px;" size="large">$ {{amount.toLocaleString()}}</Button>
                </Col>
              </div>
            </Row>
          </div>
          <div class="other-amount" style="margin-top: 10px;">
            <Row :gutter="16">
              <!-- <Col span="8">
                <Button type="primary" style="width:100%;" size="large"
                  :class="{ active: activeAmount === 6 }" v-on:click="activeAmount = 6;">$ 1,000</Button>
              </Col> -->
              <Col span="16">
                <Input @on-focus="onInputPrice()" v-model="items.price" step="any" @on-change="validatePrice" placeholder="Other amount" min="5" size="large"></Input>
              </Col>
            </Row>
          </div>
        </div>
        <Alert style="margin-top:12px" v-show="showPaymentInfo" type="warning" show-icon>A minimum of 5 upto 999,999.99 dollars donation.</Alert>
      </div>

      <div class="step-2" v-if="current == 1" style="width: 99%">

        <div class="cards">
          <img alt=" " src="@/assets/visa.png" class="card-image">
          <img alt=" " src="@/assets/master-card.png" class="card-image">
          <!-- <img src="@/assets/paypal.png" class="card-image"> -->
          <img alt=" " src="@/assets/american-express.png" class="card-image">
          <img alt=" " src="@/assets/discover.png" class="card-image">
        </div>

        <Form label-position="top" style="margin-top: 10px" :rules="ruleCustom" ref="formValidate">
          <FormItem :label="paymentLabel">
            <div class="payment-amount">
              <p style="font-size: 2em">$ {{ totalPaymentLabel }} </p> <Button v-on:click="previous()">Edit</Button>
            </div>
          </FormItem>
          <!-- <FormItem label="Name on card" prop="cardName">
            <Input v-model="ccName"></Input>
          </FormItem> -->
          <FormItem label="Card number" prop="cardNumber">
            <Input v-model="cardNumber" :maxlength="19" @on-change="debounceInput(cardInfo.number)">
              <!-- <span slot="append" v-if="cardInfo.type == 'visa'"><img src="@/assets/visa.png" class="card-image"></span> -->
              <!-- <span slot="append" v-if="cardInfo.type == 'mastercard'"><img src="@/assets/master-card.png" class="card-image"></span> -->
              <!-- <span slot="append" v-if="cardInfo.type == 'ae'"><img src="@/assets/american-express.png" class="card-image"></span> -->
              <!-- <span slot="append" v-if="cardInfo.type == 'discover'"><img src="@/assets/discover.png" class="card-image"></span> -->
            </Input>
            <img alt=" " v-if="cardInfo.type == 'visa'" src="@/assets/visa.png" class="card-image" style="position: absolute;right: 1px;bottom: 7px;">
            <img alt=" " v-if="cardInfo.type == 'mastercard'" src="@/assets/master-card.png" class="card-image" style="position: absolute;right: 1px;bottom: 7px;">
            <img alt=" " v-if="cardInfo.type == 'discover'" src="@/assets/discover.png" class="card-image" style="position: absolute;right: 1px;bottom: 7px;">
          </FormItem>
          <div class="card-security-info">
            <FormItem label="Expiry Date" prop="cardExpiry">
              <div class="expiration">
                <Input v-model="expiryNumber" :maxlength="5" placeholder="MM/YY"></Input>
              </div>
            </FormItem>
            <FormItem label="Security code" prop="cardPin">
              <div class="security">
                <Input v-model="cardInfo.pin" :maxlength="4">
                  <span slot="append">
                    <Poptip placement="top-end" width="250" v-model="popVisible">
                      <Icon type="help-circled" ></Icon>
                      <div slot="content" style="position:relative">
                        <h3 style="color: #fff;margin-bottom: 5px;">Security code</h3>
                        <Icon type="close" style="position: absolute; top: 5px; right: 0; color: #fff;" @click="popVisible = false"></Icon>
                        <div class="info-images">
                          <img alt=" " src="@/assets/visa-info.png" style="margin-right: 10px;width:100px;">
                          <img alt=" " src="@/assets/ae_info.png"  style="width:100px;">
                        </div>
                        <p align="left" style="color: #fff">For Visa, Mastercard and Discover the <br/> code is on the back of the card.</p>
                        <p align="left" style="margin-top:10px; color: #fff">For American Express the code is on <br/> the front of the card.</p>
                      </div>
                    </Poptip>
                  </span>
                </Input>
              </div>
            </FormItem>
          </div>
          <!-- <FormItem label="ZIP/Postal code">
            <Input v-model="shipping.zip_code"></Input>
          </FormItem> -->
          <Alert type="error" show-icon v-if="showError">Invalid card details. Please review your card information.</Alert>
        </Form>
        <Spin size="large" fix v-if="processing">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>Processing</div>
        </Spin>
      </div>

      <!-- <div class="step-3" v-if="current == 2" style="width: 99%; position: relative; height: 200px;">
        <Spin fix>
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>Processing...</div>
        </Spin>
      </div> -->

      <div class="step-4" v-if="current == 2" style="width: 99%; text-align: center; height: 100%">
        <Icon type="checkmark-round" style="font-size: 6em;color: #2d8cf0;margin-bottom: 20px;"></Icon>
        <p style="font-size:2.6em">Thank you!</p>
        <p style="font-size:1.6em" >You have successfully donated <br/> $ {{totalPaymentLabel}} to {{careplan.title}}.</p>
        <Button style="margin-top:25px; font-size: 20px" type="primary" size="large" long @click="close"><b>Close</b></Button>
      </div>

      <div class="under-construction" v-if="current == 4" style="width:99%">
        <!-- <p style="margin-top: 5px;font-size:16px"><b>Direct Deposit</b></p>
        <p style="margin-top: 5px;">
          <span style="color:#aaa">If you choose to donate via bank deposit, please send a photo of your deposit slip or forward the confirmation email to tapangmalasakit.ph@gmail.com</span>
          <hr style="background:#ddd;height:1px;margin:10px 0;border:none">
        </p> -->
        <div class="peso-account" style="text-align: center;margin-bottom: 15px;">
          <Button style="width:150px" type="primary" class="process-button"
            :class="{ active: directDeposit === 1 }" v-on:click="directDeposit = 1; next()">Peso Account</Button>
        </div>
        <div class="dollar-account" style="text-align: center;">
          <Button style="width:150px;" type="primary" class="process-button"
            :class="{ active: directDeposit === 2 }" v-on:click="directDeposit = 2; next()">Dollar Account</Button>
        </div>
      </div>

      <div class="under-construction" v-if="current == 5" style="width:99%">
        <p style="margin-top: 5px;font-size:16px"><b>Peso Account</b></p>
        <p style="margin-top: 5px;">
          <!-- <div class="form">Bank: <div class="underline"></div></div>
          <div class="form">Account type: <div class="underline"></div></div>
          <div class="form">Account Name: <div class="underline"></div></div>
          <div class="form">Account Number: <div class="underline"></div></div>
          <div class="form">Beneficiary/Company Address: <div class="underline"></div></div>
          <div class="form">Bank Branch Address: <div class="underline"></div></div>
          <div class="form">Bank Swift Code: <div class="underline"></div></div> -->
          <!-- <div id="pesoAccount">
            Bank: <b>Banco De Oro Universal Bank</b><br/>
            Account type: <b>Peso Account</b><br/>
            Account Name: <b>Mynd Dynamic Team, Inc.</b><br/>
            Account Number: <b>3298008503</b><br/>
            Beneficiary/Company Address: <br/>
            Bank Branch Address: <b>Pendatun Branch, Pendatun Ave. General Santos City</b><br/>
            Bank Swift Code: <br/>
            Reference No.: <b>{{refNo}}</b>
          </div> -->
          <div id="pesoAccount">
            <b>Bank:</b> China Bank<br/>
            <b>Account type:</b> checking/current<br/>
            <b>Account Name:</b> <br/>Sharpen School Alliance for the Philippines, Inc.<br/>
            <b>Account Number:</b> PHP 119600001504<br/>
            <b>Company Address:</b><br/>
            <b>Bank Address:</b> <br/>China Bank Davao Insular Village Branch, Km 8 Insular Village Phase 1 Lanang Davao City 8000<br/>
            <b>Swift Code:</b> CHBKPHMM<br/>
            <b>Reference No.:</b> {{refNo}}
          </div>
        </p>
        <Button style="margin-top: 10px;" @click="copyToClipboard('pesoAccount')">Copy to clipboard</Button>
      </div>

      <div class="under-construction" v-if="current == 6" style="width:99%">
        <p style="margin-top: 5px;font-size:16px"><b>Dollar Account</b></p>
        <p style="margin-top: 5px;">
          <!-- <div id="dollarAccount">
            Bank: <b>Banco De Oro Universal Bank</b><br/>
            Account type: <b>Dollar Account</b><br/>
            Account Name: <b>Mynd Dynamic Team, Inc.</b><br/>
            Account Number: <b>3290180608</b><br/>
            Beneficiary/Company Address: <br/>
            Bank Branch Address: <b>Pendatun Branch, Pendatun Ave. General Santos City</b><br/>
            Bank Swift Code: <b>BNORPHMM</b><br/>
            Reference No.: <b>{{refNo}}</b>
          </div> -->
          <div id="dollarAccount">
            <b>Bank:</b> <br/>
            <b>Account type:</b> <br/>
            <b>Account Name:</b> <br/><br/>
            <b>Account Number:</b> <br/>
            <b>Company Address:</b><br/>
            <b>Bank Address:</b> <br/><br/>
            <b>Swift Code:</b> <br/>
            <b>Reference No.:</b>
          </div>
        </p>
        <Button style="margin-top: 10px;" @click="copyToClipboard('dollarAccount')">Copy to clipboard</Button>
      </div>

    </div>
    <!-- <div class="bottom-buttons" v-if="showNextStep && current >= 0" style="margin-top: 10px;">
      ////<Alert v-show="showPaymentInfo" type="warning" show-icon>A minimum of 500 pesos donation.</Alert>
      ////<Checkbox v-model="monthly"> Monthly recurring donation</Checkbox>
      <div style="margin-top: 30px;">
        <div style="text-align: center;">
          <Button type="primary" v-if="showNextStepInOnlineDonation" style="margin-top:15px; font-size: 20px" size="large" long @click="next" :disabled="disableNextStep">Next step</Button>
          <Button type="primary" v-if="!showNextStepInOnlineDonation" style="margin-top:20px; font-size: 15px" @click="previous">Previous</Button>
          <Button type="text" v-if="showNextStepInOnlineDonation" style="margin-top:20px; font-size: 15px" @click="previous">Previous</Button>
        </div>
      </div>
    </div> -->
    <!-- <div class="bottom-buttons" v-if="!showNextStep && !showPayAmount">
      <Button type="primary" style="margin-top:15px; font-size: 20px" size="large" icon="ios-locked" long  v-on:click="verifyUserInfo()">{{ paymentLabelBtn }}</Button>
    </div> -->
    <div style="position: absolute; bottom:0;right:0px">
      <div v-if="showNextStep && current >= 0">
        <!-- <Button type="text" v-if="showNextStepInOnlineDonation" @click="previous">Previous</Button>   -->
        <Button type="primary" v-if="!showNextStepInOnlineDonation" @click="previous">Previous</Button>
        <Button type="primary" v-if="showNextStepInOnlineDonation" @click="next" :disabled="disableNextStep">Next step</Button>
      </div>
      <Button type="text" v-if="!showNextStep && !showPayAmount" v-on:click="previous">Previous</Button>
      <Button type="primary"  v-if="!showNextStep && !showPayAmount" icon="ios-locked" v-on:click="verifyUserInfo()">{{ paymentLabelBtn }}</Button>
      <Button type="primary" v-if="current == -1" :disabled="typeOfDonation == 0" @click="next">Next step</Button>
    </div>
  </div>
</template>

<script>
  import Utils from '@/utils.js'
  import _ from 'lodash'

  export default {
    name: 'OnlinePaymentComponent',
    data(){
      const validateCardName = (rule, value, callback) => {
        if(this.ccName){
          let name = this.splitCCName(this.ccName)
          if(name.length > 1){
            this.cardInfo.first_name = name.slice(0, name.length-1).join(" ")
            this.cardInfo.last_name = name[name.length-1]
            callback();
          }else{
            callback(new Error('Please enter a valid name'));
          }
        }else{
          callback(new Error('Name should not be empty'));
        }
      };
      const validateCardNumber = (rule, value, callback) => {
        if(this.cardInfo.number){
          if(Utils.getCardType(this.cardInfo.number)){
            this.cardInfo.type = Utils.getCardType(this.cardInfo.number)
            if(this.cardInfo.type == 'visa' || this.cardInfo.type == 'amex' || this.cardInfo.type == 'mastercard' || this.cardInfo.type == 'discover'){
              callback();
            }else{
              callback(new Error('Card number is not supported'));
            }
          }else{
            this.cardInfo.type = null
            callback(new Error('Please enter a valid card number'));
          }
        }else{
          callback(new Error('Card number should not be empty'));
        }
      };
      const validateExpiryDate = (rule, value, callback) => {
        if(this.expiryNumber){
          callback();
        }else{
          callback(new Error('Expire date should not be empty'));
        }
      };
      const validateCardPin = (rule, value, callback) => {
        if(this.cardInfo.pin){
          if(this.cardInfo.pin.length > 2){
            callback();
          }else{
          callback(new Error('Please enter a valid security code'));
          }
        }else{
          callback(new Error('Security code should not be empty'));
        }
      }
      return {
        popVisible: false,
        typeOfDonation: 1,
        additionalAmount: false,
        visibleInfo: false,
        showPaymentInfo: false,
        disableNextStep: true,
        showNextStep: true,
        showPayAmount: false,
        current: 0,
        showNextStepInOnlineDonation: true,
        activeAmount: null,
        amounts: [5, 20, 100],
        amount: null,
        expire_date: null,
        monthly: false,
        ccName: null,
        showError: false,
        directDeposit: 0,
        cardInfo: {
          type: null,
          number: null,
          expire_month: null,
          expire_year: null,
          pin: null,
          first_name: null,
          last_name: null
        },
        items: {
          name: null,
          sku: null,
          description: null,
          quantity: 1,
          price: null,
        },
        shipping: {
          address: null,
          city: null,
          zip_code: null,
          phone: null,
        },
        ruleCustom: {
          // cardName: [
          //   { validator: validateCardName, trigger: 'blur' }
          // ],
          cardNumber: [
            { validator: validateCardNumber, trigger: 'blur' }
          ],
          cardExpiry: [
            { validator: validateExpiryDate, trigger: 'blur' }
          ],
          cardPin: [
            { validator: validateCardPin, trigger: 'blur' }
          ]
        }
      }
    },
    watch: {
      current: function(n, o){
        if(n == -2){
          this.backToHome()
        }else if (n == 2){
          this.showNextStep = false
          this.showPayAmount = true

          // setTimeout(() => {
          //   this.current = 3
          // }, 5000)
        }else if (n == 1 || n==3 ){
          this.showNextStep = false
        }else if (n == 4){
          this.showNextStep = true
          this.showNextStepInOnlineDonation = true
          // this.disableNextStep = false
        }else if (n == 5 || n == 6){
          this.showPayAmount = false
          this.showNextStepInOnlineDonation = false
        }else{
          this.showNextStep = true
          this.showNextStepInOnlineDonation = true
        }
      },
      'items.price': function(n, o){
        if(n >= 500 ){
          // this.activeAmount = 7
          this.disableNextStep = false
          this.additionalAmount = false
        } else if (n !== null){
          this.disableNextStep = true
        }
      },
      activeAmount: function(n, o){
        if(n !== null){
          this.showPaymentInfo = false
          this.items.price = null
          this.disableNextStep = false
        }else{
          this.disableNextStep = true
          this.showPaymentInfo = true
        }
      },
      directDeposit: function(n, o){
        if(n){
          this.disableNextStep = false
        }
      },

    },
    computed: {
      refNo: {
        get() {
          return this.careplan.id.slice(32, 40);
        }
      },
      totalPaymentLabel() {
        let label = this.totalPayment.toLocaleString()
        if (this.monthly) {
          label += " per month";
        }
        return label;
      },
      paymentLabelBtn() {
        let label = 'Donate ' + this.totalPayment.toLocaleString();
        if (this.monthly) {
          label += " per month";
        }
        return label;
      },
      careplan: {
        get () {
          return this.$store.state.resource.singleResource.data
        }
      },
      paymentLabel() {
        return !this.monthly ? 'Donation amount' : 'Monthly donation amount'
      },
      totalPayment() {
        if (this.amounts[this.activeAmount]) {
          return this.amounts[this.activeAmount];
        } else {
          return parseFloat(this.items.price);
        }
      },
      cardNumber: {
        get () {
          return this.CCFormatter(this.cardInfo.number)
        },
        set (v) {
          this.cardInfo.number = v;
        }
      },
      expiryNumber: {
        get () {
          return this.CCDateFormatter(this.expire_date)
        },
        set (v) {
          this.expire_date = v;
        }
      },
      careplan: {
        get () {
          return this.$store.state.resource.singleResource.data
        }
      },
      processing: {
        get () {
          return this.$store.state.donation.processingDonation
        }
      }
    },
    methods: {
      validatePrice() {
        if (this.items.price) {
          if( this.items.price < 5 )
            this.showPaymentInfo = true;
          if(this.items.price > 999999.99)
            this.showPaymentInfo = true;
        }
      },
      backToHome() {
        this.$emit('backToHome')
      },
      close() {
        this.$emit('on-close')
      },
      next () {
        console.log(">>>", this.current);
        
        if(this.typeOfDonation == 1){
          if (this.current == 3) {
            this.current = 0;
          } else {
            this.current += 1;
          }
          console.log(">>> ::", this.current)
        }else{
          if(this.current != 4){
            this.current = 6;
          }
        }
      },
      previous () {
        this.current -= 1;
        console.log(this.current)
        if(this.current === 3){
          this.current = -1
        }else if(this.current === 5){
          this.current = -1;
          console.log('triggered')
        }
        console.log(this.current);
        
      },
      showSecurityInfo(){
        if(this.visibleInfo)
          this.visibleInfo = false
        else
          this.visibleInfo = true
      },
      onInputPrice(){
        this.activeAmount = null
      },
      CCFormatter(value){
        if(value){
          var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
          var matches = v.match(/\d{4,16}/g);
          var match = matches && matches[0] || ''
          var parts = []
          for (let i=0, len=match.length; i<len; i+=4) {
            parts.push(match.substring(i, i+4))
          }
          if (parts.length) {
            return parts.join(' ')
          } else {
            return value
          }
        }
      },
      CCDateFormatter(value){
        if(value){
          return value.replace(
            /^([1-9]\/|[2-9])$/g, '0$1/'
          ).replace(
            /^(0[1-9]{1}|1[0-2]{1})$/g, '$1/'
          ).replace(
            /^([0-1]{1})([3-9]{1})$/g, '0$1/$2'
          ).replace(
            /^(\d)\/(\d\d)$/g, '0$1/$2'
          ).replace(
            /^(0?[1-9]{1}|1[0-2]{1})([0-9]{2})$/g, '$1/$2'
          ).replace(
            /^([0]{1,})\/|[0]{1,}$/g, '0'
          ).replace(
            /[^\d\/]|^[\/]{0,}$/g, ''
          ).replace(
            /\/\//g, '/'
          );
        }
      },
      splitCCName(name){
        var n = name.split(" ");
        return n
      },
      fillUpItems(){
        this.items.name = this.careplan.title
        this.items.sku = this.careplan.id
        this.items.description = 'Donation to ' + this.careplan.title
        this.items.quantity = 1
        this.items.price = parseFloat(this.totalPaymentLabel.replace(/[^\d\.\-]/g, ""))
      },
      verifyUserInfo(){
        this.$refs['formValidate'].validate((valid) => {
          if (valid) {
            if(this.expiryNumber){
              var n = this.expiryNumber.split("/");
              this.cardInfo.expire_month = n[0];
              this.cardInfo.expire_year = '20' + n[1];
            }
            this.fillUpItems();

            let data = {
              card: this.cardInfo,
              items: [this.items],
              description: 'Donation to ' + this.careplan.title,
              item_id: this.careplan.id,
              amount: this.items.price
            }

            if( this.$route.query.isOrganization ) {
              data.app_id = Cons[0].BRAND_ID;
              data.item_id = this.$route.query.organization
            }

            this.showError=false

            this.$store.dispatch('donation/payWithPaypal', data).then(res => {
              this.next();
            },
            error => {
              // console.log(error);
              this.showError=true
            });

          } else {
            // this.$Message({
            //   closable: true,
            //   // durationInSec:3,
            //   title: { content:'Fail' },
            //   icon: 'alert',
            //   message: { content: 'Something went wrong.' },
            //   buttons: [
            //     { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
            //   ]
            // });
          }
        })
      },
      copyToClipboard(containerid) {
        var range = document.getSelection().getRangeAt(0);
            range.selectNode(document.getElementById(containerid));
            window.getSelection().addRange(range);
            document.execCommand("copy")
      },
      debounceInput: _.debounce(function (cardNumber) {
        // console.log(cardNumber)
        // console.log(Utils.getCardType(cardNumber))
      }, 500)
    }
  }
</script>
